import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from 'react-redux';

import { addingSource } from 'apps/auth/actions/cardsAction';
import Account from 'apps/auth/components/cards/Account';
import Card from 'apps/auth/components/cards/Card';
import CardsAccountsList from 'apps/auth/components/cards/CardsAccountsList';
import EmptyCards from 'apps/auth/components/cards/EmptyCards';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import BasePage from 'apps/auth/components/utils/BasePage';
import { ACCOUNT, ACH_ACCOUNT, PAYMENT_BANK_ACCOUNT, PAYMENT_BANK_CARD } from 'apps/auth/constants/Constants';
import { AUTH_PROFILE } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';

import AddCardOrAccountModal from './AddCardOrAccountModal';
import AddCardOrAccountPopup from './AddCardOrAccountPopup';
import DeleteOrRenameCardPopup from './DeleteOrRenameCardPopup';

const SCREEN_LIST = 'screen_list';
const SCREEN_EMPTY = 'screen_empty';
const SCREEN_CARD = 'screen_card';
const SCREEN_ACCOUNT = 'screen_account';

const filterArray = (array) => {
    const newObject = {
        accountsArray: [],
        cardsArray: [],
    };
    if (array?.length > 0) {
        return array.reduce((obj, value) => {
            if (value.type === ACCOUNT || value.type === ACH_ACCOUNT) {
                obj.accountsArray.push(value);
            } else {
                obj.cardsArray.push(value);
            }
            return obj;
        }, newObject);
    } else {
        return newObject;
    }
};

const MyCards = (props) => {
    const isNotEmptyArray = props.cards?.length > 0;
    const initialState = isNotEmptyArray ? SCREEN_LIST : SCREEN_EMPTY;
    const [screen, setScreen] = useState(initialState);
    const [currentIndex, setCurrentIndex] = useState(null);

    const { cardsArray, accountsArray } = useMemo(() => filterArray(props.cards), [props.cards]);
    const { cardPan } = useExtra();
    const popupRef = useRef(null);

    useEffect(() => {
        if (props.cards?.length > 0) {
            setScreen(SCREEN_LIST);
        }
        if (props.cards?.length === 0) {
            setScreen(SCREEN_EMPTY);
        }
    }, [props.cards?.length]);

    useEffect(() => {
        if (cardPan) {
            if (props.canPayOnCard) {
                props.addingSource(PAYMENT_BANK_CARD, <AddCardOrAccountModal />, true);
            } else if (props.canPayOnAccount) {
                props.addingSource(PAYMENT_BANK_ACCOUNT, <AddCardOrAccountModal />);
            }
        }
    }, [cardPan]);

    if (cardPan) {
        return <CommonPage />;
    }

    const onClickHandler = (e, el, index) => {
        e.preventDefault();
        if (el.type === ACCOUNT || el.type === ACH_ACCOUNT) {
            setScreen(SCREEN_ACCOUNT);
        } else {
            setScreen(SCREEN_CARD);
        }
        setCurrentIndex(index);
    };

    const openPopupOrModal = (e) => {
        e.preventDefault();
        if (props.canPayOnCard && props.canPayOnAccount) {
            popupRef.current?.open(<AddCardOrAccountPopup popupRef={popupRef} />);
        } else if (props.canPayOnCard) {
            props.addingSource(PAYMENT_BANK_CARD, <AddCardOrAccountModal />, true);
        } else if (props.canPayOnAccount) {
            props.addingSource(PAYMENT_BANK_ACCOUNT, <AddCardOrAccountModal />);
        }
    };

    const getOnClickIcon = () => {
        if (!isScreenEmptyOrList) {
            return () => setScreen(SCREEN_LIST);
        }
    };
    const isScreenEmptyOrList = screen === SCREEN_EMPTY || screen === SCREEN_LIST;

    const getSelectedItem = (currentScreen) => {
        if (currentScreen === SCREEN_CARD) {
            return cardsArray?.[currentIndex];
        } else {
            return accountsArray?.[currentIndex];
        }
    };

    return (
        <>
            <CommonPage
                backUrl={isScreenEmptyOrList ? AUTH_PROFILE : '#'}
                onClickIcon={getOnClickIcon()}
                rightHeaderComponent={
                    (screen === SCREEN_CARD && cardsArray.length > 0) || (screen === SCREEN_ACCOUNT && accountsArray.length > 0) ? (
                        <DiskButton
                            iconName="dots"
                            type="button"
                            raised={false}
                            onClick={() => {
                                popupRef.current?.open(<DeleteOrRenameCardPopup selectedCard={getSelectedItem(screen)} popupRef={popupRef} />);
                            }}
                        />
                    ) : null
                }
            >
                <HeaderPanel
                    title={props.headerTitle}
                    buttonRowCaption={isScreenEmptyOrList ? props.addNew : ''}
                    buttonRowOnClick={(e) => {
                        openPopupOrModal(e);
                    }}
                />
                {screen === SCREEN_EMPTY && !isNotEmptyArray && <EmptyCards title={props.cardsCustomTitle} />}
                {screen === SCREEN_LIST && isNotEmptyArray && (
                    <CardsAccountsList cardsArray={cardsArray} accountsArray={accountsArray} onClickHandler={onClickHandler} />
                )}
                {screen === SCREEN_CARD && cardsArray.length > 0 && <Card card={cardsArray?.[currentIndex]} />}
                {screen === SCREEN_ACCOUNT && accountsArray.length > 0 && <Account account={accountsArray?.[currentIndex]} />}
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        cards: state.cards.cards,
        headerTitle: state.messages.pageMessages.headerTitle,
        cardsCustomTitle: state.messages.pageMessages.cardsCustomTitle,
        canPayOnCard: state.auth.canPayOnCard,
        canPayOnAccount: state.auth.canPayOnAccount,
        addNew: state.messages.pageMessages.addNew,
    };
};
export default connect(mapStateToProps, { addingSource })(BasePage(MyCards));
